var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "c-dialog",
    _vm._g(
      {
        ref: "saveResumeDialog",
        staticClass: "cog-save-resume-dialog",
        attrs: { visible: _vm.open },
        on: { opened: _vm.handleDialogOpened }
      },
      _vm.$listeners
    ),
    [
      _c("c-row", { attrs: { slot: "title" }, slot: "title" }, [
        _c("div", { staticClass: "cog-content cog-col cog-col--24" }, [
          _c("h2", { staticClass: "cog-heading" }, [
            _vm._v(_vm._s(_vm.resourceData("save-and-resume-message")))
          ]),
          _vm._v(" "),
          _c("p", [_vm._v(_vm._s(_vm.saveMessage))])
        ])
      ]),
      _vm._v(" "),
      !_vm.hideLink
        ? _c(
            "c-row",
            [
              _c(
                "c-field",
                {
                  attrs: {
                    "field-id": "cog-save-resume-link",
                    label: _vm.resourceData("save-and-resume-copy-link-label")
                  }
                },
                [
                  _c("c-input", {
                    attrs: { id: "cog-save-resume-link", value: _vm.link },
                    nativeOn: {
                      click: function($event) {
                        return $event.target.select()
                      }
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "c-row",
        [
          _c(
            "c-field",
            { attrs: { "field-id": _vm.randomUUID + "-email" } },
            [
              _c("label", [
                _c("span", [
                  _vm._v(
                    _vm._s(_vm.resourceData("save-and-resume-email-label"))
                  )
                ]),
                _vm._v(" "),
                !_vm.readOnly
                  ? _c("span", { staticClass: "cog-asterisk" }, [_vm._v("*")])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c(
                "c-row",
                [
                  _c("c-input", {
                    staticClass: "cog-input--long",
                    attrs: {
                      id: _vm.randomUUID + "-email",
                      type: "email",
                      required: "true",
                      value: _vm.email,
                      readonly: _vm.readOnly
                    },
                    on: {
                      input: _vm.handleEmailInput,
                      change: _vm.handleEmailChange
                    },
                    nativeOn: {
                      keydown: function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        $event.preventDefault()
                        return _vm.sendEmail.apply(null, arguments)
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "cog-input" },
                    [
                      _c(
                        "c-status-button",
                        {
                          staticClass:
                            "cog-save-resume__button cog-button--primary",
                          attrs: {
                            disabled: _vm.disabled,
                            status: _vm.emailStatus,
                            duration: 4000
                          },
                          nativeOn: {
                            click: function($event) {
                              return _vm.sendEmail.apply(null, arguments)
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.resourceData("send-button-text")))]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("transition", { attrs: { name: "cog-error-message" } }, [
                    _vm.emailError && _vm.showEmailError
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "cog-error-message cog-error-message--container-footer"
                          },
                          [_vm._v(_vm._s(_vm.emailError))]
                        )
                      : _vm._e()
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }